// extracted by mini-css-extract-plugin
module.exports = {"homeSection":"Home_homeSection__2pObN","slider":"Home_slider__KSaHo","ul":"Home_ul__1eMtk"};